var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.417,
    height: 23.117,
    viewBox: "1117 3749.983 28.417 23.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1142.806 3750h-23.205a2.601 2.601 0 0 0-2.601 2.6v17.88a2.601 2.601 0 0 0 2.601 2.6h23.205a2.601 2.601 0 0 0 2.601-2.6v-17.88a2.601 2.601 0 0 0-2.601-2.6Zm-16.508 15.979-4.648 4.65a1.556 1.556 0 0 1-2.198 0 1.554 1.554 0 0 1 0-2.198l4.65-4.65a1.554 1.554 0 0 1 2.196 2.198Zm16.657 4.65a1.556 1.556 0 0 1-2.198 0l-4.648-4.65a1.554 1.554 0 0 1 2.196-2.198l4.65 4.65c.607.607.607 1.59 0 2.198Zm0-15.98-7.59 7.557a5.905 5.905 0 0 1-4.162 1.692c-1.775 0-3.138-.673-4.133-1.664l-7.618-7.584a1.554 1.554 0 1 1 2.198-2.198l7.778 7.785c1.026 1.026 2.551 1.026 3.606-.028l7.723-7.757a1.554 1.554 0 1 1 2.198 2.198Z",
    fill: "#357fd8",
    fillRule: "evenodd",
    "data-name": "Path 77"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.fe156d30c13378f4c6e4f58a94e6551a.svg";
export { ForwardRef as ReactComponent };